import React from 'react';

const ScanIcon = (props) => (
  <svg {...props} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M17 7.00002V1.00004L11 1.00004M1 11L1 17H7.00002M7.00002 1L1.00004 1L1.00004 7.00002M11 17H17V11'
      stroke={props.fill}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M5 9L13 9' stroke={props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default ScanIcon;
